import API from "../../api/apiAdmin";

export const ContactPageSettingServices = {
    /**
     * Fetch the contact page settings.
     */
    getSettings: async () => {
        try {
            const response = await API.get("/admin/contact-settings/");
            return response.data;
        } catch (error) {
            console.error("Error fetching contact settings:", error);
            throw error;
        }
    },

    /**
     * Update contact page settings.
     * @param {object} data
     */
    updateSettings: async (data) => {
        try {
            const response = await API.put("/admin/contact-settings/", data);
            return response.data;
        } catch (error) {
            console.error("Error updating contact settings:", error);
            throw error;
        }
    }
};
